import React from 'react'
import { Check, Clock, EyeIcon, TriangleExclamation } from '../../../../components/icons/Icons'
import { Col, Row } from 'react-bootstrap'

const GlobalCard = ({ data }) => {
    return (
        
            <Col sm="6" className='mb-4'>
                <div className='emp-tds-card'>
                    {
                        data.map(item => {
                            return item.isH3 ? <div className='d-flex align-items-center justify-content-between gap-2 mb-2'>
                                <h3 className='color-white mb-3'>{item.label}</h3> <span className={item.classname}>{item.icon} {item.badgeText} </span>
                            </div> : item.isLabel ? <div className='d-flex align-items-center justify-content-between gap-2 mb-2'>
                                <span className='color-gray'>{item.label}</span> <span className={item.classname}> {item.icon} <span className='capitalize-word'>{item.value}</span> </span>
                            </div> : item.isHr ? <hr className='color-gray' /> : item.isLinkBtn ? <div className={ `d-flex align-items-center gap-2 mt-3 ${item.classname}`}>
                                {item.icon} <span className='capitalize-word'>{item.label}</span>
                            </div> : null
                        })
                    }



                </div>
            </Col>

       

    )
}

export default GlobalCard